import { call, put, select, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { createFacilityExtraActions, facilityExtrasActions, facilityInfoActions, updateFacilityExtraActions } from "./visitorInformation.actions";
import { createFacilityInfoApi, getContentApi, getFacilityInfoApi, updateFacilityInfoApi } from "./visitorInformation.api";
import { FacilityExtraDto, FacilityInfoDto } from "./visitorInformation.dtos";

function* setExtras(result: FacilityExtraDto[], newItems: FacilityExtraDto[]) {
    result.forEach(i => {
      let oldItemIndex = newItems.findIndex(s => s.id === i.id);
      if (oldItemIndex === -1) newItems.push(i);
      else newItems[oldItemIndex] = i;
    }); 
    yield put({ type: getType(facilityExtrasActions.success), payload: newItems });
    sessionStorage.setItem(`facility_content`, JSON.stringify(newItems));
}

function* handleGetExtras(request: ReturnType<typeof facilityExtrasActions.request>) {
    const storeList: FacilityExtraDto[] = yield select(state => state.facilityInfo.content);
    const contentStorage = sessionStorage.getItem(`facility_content`);
    const sessionContent = contentStorage === null ? [] : JSON.parse(contentStorage) as FacilityExtraDto[];
    const facilityInfo: FacilityExtraDto[] = 
    // storeList !== undefined && storeList.length !== 0 ? storeList :
    //   sessionContent.length !== 0 ? sessionContent :
        yield call(getContentApi);
  
    yield put({ type: getType(facilityExtrasActions.success), payload: facilityInfo });
    sessionStorage.setItem(`facility_content`, JSON.stringify(facilityInfo));
}

function* handleGetInfo(request: ReturnType<typeof facilityInfoActions.request>) {
    const storeUser: FacilityInfoDto = yield select(state => state.facilityInfo.info);
    const info: FacilityInfoDto = (storeUser !== undefined && storeUser.id !== undefined && storeUser.id === request.payload) ? storeUser : yield call(getFacilityInfoApi);
  
    yield put({ type: getType(facilityInfoActions.success), payload: info });
  }

function* handleUpdateExtras(request: ReturnType<typeof updateFacilityExtraActions.request>) {
  const storeList = yield select(state => state.facilityInfo.content);
  const updatedFacilityExtra: FacilityExtraDto[] = yield call(updateFacilityInfoApi, request.payload);

  yield put({ type: getType(facilityExtrasActions.success), payload: updatedFacilityExtra });
}

function* handleCreateExtras(request: ReturnType<typeof createFacilityExtraActions.request>) {
  const storeList = yield select(state => state.facilityInfo.content);
  const createdFacilityExtra: FacilityExtraDto[] = yield call(createFacilityInfoApi, request.payload);

  yield put({ type: getType(facilityExtrasActions.success), payload: createdFacilityExtra });
}

export function* watchGetExtrasRequest() {
    try {
      yield takeLatest(getType(facilityExtrasActions.request), handleGetExtras);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchGetInfoRequest() {
    try {
      yield takeLatest(getType(facilityInfoActions.request), handleGetInfo);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchUpdateExtraRequest() {
    try {
      yield takeLatest(getType(updateFacilityExtraActions.request), handleUpdateExtras);
    }
    catch (err) {
      console.log(err);
    }
}
  
export function* watchCreateExtraRequest() {
    try {
      yield takeLatest(getType(createFacilityExtraActions.request), handleCreateExtras);
    }
    catch (err) {
      console.log(err);
    }
}